import { usePermissions } from '@/hooks/usePermissions';
import { useAuthStore } from '@/stores/auth-store';
import { canOpenPayPath } from '@/lib/dunning-pay-path';

/**
 * `canOpenPayPath` for the signed-in viewer: the one place every dunning surface asks
 * "can this person open the page the pay button goes to?". Same sources as the Settings
 * nav: `isRootAdmin` from `usePermissions`, the `hide*` flags from `me.brandingData`.
 */
export function useCanOpenPayPath(path: string): boolean {
  const { isRootAdmin } = usePermissions();
  const brandingData = useAuthStore((s) => s.me?.brandingData);
  return canOpenPayPath(path, {
    isRootAdmin,
    hidePaymentHistoryPages: !!brandingData?.hidePaymentHistoryPages,
    hideSubscriptionPages: !!brandingData?.hideSubscriptionPages,
  });
}
